"use client";

import { ShieldCheck, BarChart3, Hotel, Lock, Clock } from "lucide-react";
import { useI18n } from "@/lib/i18n/I18nProvider";

export function TrustBadges() {
  const { t } = useI18n();

  const BADGES = [
    {
      icon: ShieldCheck,
      title: t("landing.trustBadges.badge1Title"),
      description: t("landing.trustBadges.badge1Desc"),
    },
    {
      icon: BarChart3,
      title: t("landing.trustBadges.badge2Title"),
      description: t("landing.trustBadges.badge2Desc"),
    },
    {
      icon: Hotel,
      title: t("landing.trustBadges.badge3Title"),
      description: t("landing.trustBadges.badge3Desc"),
    },
    {
      icon: Lock,
      title: t("landing.trustBadges.badge4Title"),
      description: t("landing.trustBadges.badge4Desc"),
    },
    {
      icon: Clock,
      title: t("landing.trustBadges.badge5Title"),
      description: t("landing.trustBadges.badge5Desc"),
    },
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {BADGES.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <div
                key={index}
                className="group flex flex-col items-center text-center p-6 rounded-xl bg-keiront-mist/50 border border-slate-200 hover:border-keiront-green/30 hover:shadow-md transition-all duration-200 hover:translate-y-[-2px]"
              >
                <div className="mb-3">
                  <Icon className="w-8 h-8 text-keiront-green" />
                </div>
                <h3 className="font-semibold text-sm text-keiront-obsidian mb-2">
                  {badge.title}
                </h3>
                <p className="text-xs text-slate-600 leading-snug">
                  {badge.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
